import React from 'react';

interface DashboardStatsProps {
  dailySummary: any;
  inventoryStatus: any;
  userRole: string;
}

const DashboardStats: React.FC<DashboardStatsProps> = ({ 
  dailySummary, 
  inventoryStatus, 
  userRole 
}) => {  const getStatsForRole = () => {
    const baseStats = [
      {
        name: 'Total Orders Today',
        value: dailySummary?.orders?.total || 0,
        icon: 'O',
        color: 'bg-blue-500',
        textColor: 'text-blue-600',
        change: null,
      },
      {
        name: 'Completed Orders',
        value: dailySummary?.orders?.completed || 0,
        icon: '✓',
        color: 'bg-green-500',
        textColor: 'text-green-600',
        change: dailySummary?.orders?.total ? 
          `${Math.round((dailySummary.orders.completed / dailySummary.orders.total) * 100)}%` : '0%',
      },
      {
        name: 'Pending Orders',
        value: dailySummary?.orders?.pending || 0,
        icon: '•',
        color: 'bg-yellow-500',
        textColor: 'text-yellow-600',
        change: null,
      },
      {
        name: 'Total Inventory',
        value: inventoryStatus?.total_stock || 0,
        icon: '#',
        color: 'bg-purple-500',
        textColor: 'text-purple-600',
        change: null,
      }
    ];

    // Add role-specific stats
    if (userRole === 'manager') {
      baseStats.push({
        name: 'Low Stock Alerts',
        value: inventoryStatus?.low_stock_alerts?.length || 0,
        icon: '!',
        color: 'bg-red-500',
        textColor: 'text-red-600',
        change: null,
      });
    }

    if (userRole === 'worker') {
      baseStats.push({
        name: 'My Assigned Orders',
        value: dailySummary?.my_assigned_orders || 0,
        icon: 'U',
        color: 'bg-indigo-500',
        textColor: 'text-indigo-600',
        change: null,
      });
    }

    return baseStats;
  };

  const stats = getStatsForRole();

  return (    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {stats.map((stat) => (
        <div key={stat.name} className="bg-white overflow-hidden shadow rounded-lg border border-gray-200">
          <div className="p-5">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <div className={`${stat.color} p-3 rounded-md flex items-center justify-center`}>
                  <span className="text-xl font-bold text-white">
                    {stat.icon}
                  </span>
                </div>
              </div>
              <div className="ml-5 w-0 flex-1">
                <dl>
                  <dt className="text-sm font-medium text-gray-500 truncate">
                    {stat.name}
                  </dt>
                  <dd className="flex items-baseline">
                    <div className={`text-2xl font-semibold ${stat.textColor || 'text-gray-900'}`}>
                      {typeof stat.value === 'number' ? stat.value.toLocaleString() : stat.value}
                    </div>
                    {stat.change && (
                      <div className="ml-2 flex items-baseline text-sm font-semibold text-green-600">
                        {stat.change}
                      </div>
                    )}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStats;
